import ConversationAPI from '../../api/inbox/conversation';

// Bolinhas vermelhas de "Todas as conversas" e "Não atendidas" no menu lateral:
// quantas conversas abertas têm mensagem não lida (mesma regra da bolinha verde).
const ESPERA_PARA_AGRUPAR_EVENTOS = 1500;
let atualizacaoAgendada = null;

const state = { todas: 0, naoAtendidas: 0 };

export const getters = {
  getTodas: s => s.todas,
  getNaoAtendidas: s => s.naoAtendidas,
};

export const mutations = {
  SET_CONTAGENS(s, { todas = 0, nao_atendidas: naoAtendidas = 0 }) {
    s.todas = todas;
    s.naoAtendidas = naoAtendidas;
  },
};

export const actions = {
  async atualizar({ commit }) {
    try {
      const { data } = await ConversationAPI.unreadCounts();
      commit('SET_CONTAGENS', data || {});
    } catch {
      // Sem contagem, a bolinha só não aparece; a lista continua funcionando.
    }
  },

  // Chamado a cada evento de conversa em tempo real: agrupa rajadas numa só busca.
  agendarAtualizacao({ dispatch }) {
    clearTimeout(atualizacaoAgendada);
    atualizacaoAgendada = setTimeout(
      () => dispatch('atualizar'),
      ESPERA_PARA_AGRUPAR_EVENTOS
    );
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
